import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getParticipantManagementInboxData = createAsyncThunk(
    "participant-management/inbox",
    async ({ user, pagination }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getMakerParticipantList;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getCheckerParticipantList;
                apiURL = base + endpointpath + `/${pagination.pageSize}/${pagination.currentPage}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddedParticipantReview = createAsyncThunk(
    "participant-management/inbox/added-participant-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addParticipantMakerReturnedTasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addParticipantCheckerReviewTasks;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postUpdatedParticipantReview = createAsyncThunk(
    "participant-management/inbox/updated-participant-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updateParticipantMakerReviewTasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updateParticipantCheckerReviewTasks;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const participantManagementInboxSlice = createSlice({
    name: "participant-management-inbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL PARTICIPANTS
            .addCase(getParticipantManagementInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getParticipantManagementInboxData.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = data || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getParticipantManagementInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD PARTICIPANT REVIEW
            .addCase(postAddedParticipantReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddedParticipantReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddedParticipantReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // UPDATE PARTICIPANT REVIEW
            .addCase(postUpdatedParticipantReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postUpdatedParticipantReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postUpdatedParticipantReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default participantManagementInboxSlice.reducer;